module.exports = __webpack_public_path__ + "static/two-a697b345bf9ad050e5cedd59924179a1.png";